<template>
<v-container fluid fill-height>
    <v-layout v-if="loading" align-center justify-center>
        <v-progress-circular indeterminate></v-progress-circular>
    </v-layout>
    <v-layout v-else>
        <v-flex xs12>
            <v-card>
                <v-toolbar color="primary" class="white--text">
                    <v-toolbar-title>Attributes</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-icon dark>layers</v-icon>
                </v-toolbar>
                <v-layout wrap>
                    <v-flex xs12>
                        <v-alert :value="error != null" outline type="error">
                            {{error}}
                        </v-alert>
                    </v-flex>
                    <v-flex xs12 sm3 offset-sm1>
                        <v-text-field v-model="search" append-icon="search" label="Filter" single-line hide-details></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm3 offset-sm1>
                        <v-checkbox class="active-checkbox" label="Active Only" v-model="activeOnly" hide-details></v-checkbox>
                    </v-flex>
                    <v-flex xs12 sm2 offset-sm1>
                        <v-btn color="primary" block @click="showEditAddAttribute({ UserDefined: true, AttributeValues: [] })">
                            Add
                        </v-btn>
                    </v-flex>
                </v-layout>
                <v-layout pt-3>
                    <v-flex xs12>
                        <attribute-table :search="search" :filteredItems="filteredItems" @edit="showEditAddAttribute($event)"></attribute-table>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-flex>
    </v-layout>
    <v-dialog 
            :value="editing"
            fullscreen 
            hide-overlay 
            transition="dialog-bottom-transition">
            <attribute-edit 
                v-if="editing"
                :item="editItem"
                :availableCategories="availableCategories"
                :submitLoading="loading"
                :submitError="error"
                @submit="handleSubmit"
                @cancel="cancelEdit()">
            </attribute-edit>
        </v-dialog>
</v-container>
</template>

<script>
import AttributeTable from "@/components/configuration/attributes/AttributeTable.vue";
import AttributeEdit from "@/components/configuration/attributes/AttributeEdit.vue";

import AttributeApi from '@/api/attributeApi'
import ProductCategoryApi from "@/api/productCategoryApi";

export default {
    components: {
        AttributeTable: AttributeTable,
        AttributeEdit: AttributeEdit
    },
    data() {
        return {
            editing: false,
            error: null,
            loading: false,
            search: "",
            activeOnly: true,
            editItem: null,
            attributes: [],
            availableCategories: []
        }
    },
    computed: {
        filteredItems() {
            return this.attributes.filter(c => c.IsActive === this.activeOnly && c.UserDefined);
        }
    },
    methods: {
        async loadAttributes() {
            this.loading = true;
            this.error = null;

            try {
                this.attributes = await AttributeApi.getAttributes();
                let productCategories = await ProductCategoryApi.getProductCategories();

                this.availableCategories = productCategories.map(x => {
                    return {
                        ProductCategoryID: x.ID,
                        ProductCategoryName: x.Name
                    };
                });

            } catch (err) {
                this.error = err;
            }

            this.loading = false;
        },
        showEditAddAttribute(item) {            
            this.editItem = item;
            this.editing = true;
        },
        cancelEdit() {
            this.editItem = null;
            this.error = null;
            this.editing = false;
        },
        async handleSubmit(item) {
            if (this.attributes.filter(a => a.Name.trim() === item.Name.trim() && a.AttributeID !== item.AttributeID).length > 0) {
                this.error = "Attribute with the same name already exists."
                return;
            }

            this.loading = true;            

            try {
                let response = {};

                if (item.AttributeID > 0) {
                    response = await AttributeApi.updateAttribute(item);                    
                } else {                    
                    response = await AttributeApi.addAttribute(item);                    
                }                

                if (!response.Success) {
                    this.error = response.ErrorMessages.join(', ');
                    return;
                }

                this.editing = false;
            } catch (err) {
                this.error = err;
                return;

            } finally {
                this.loading = false;
            }

            await this.loadAttributes();
        }
    },
    async created() {
        await this.loadAttributes();
    }
}
</script>
